<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="医師情報"
        :ok-only="true"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @hidden="close">
        <div
            v-if="doctor !== null"
            class="p-2 modalWrapper">
            <div
                class="copyDeeplinkBtn"
                :class="{ 'copied' : isCopiedDeeplink }"
                @click="copyDeeplink">
                <div v-if="isCopiedDeeplink">
                    <b-icon-clipboard-check></b-icon-clipboard-check>
                    <span>コピーしました！</span>
                </div>
                <div v-else>
                    <b-icon-clipboard></b-icon-clipboard>
                    <span>URLをコピー</span>
                </div>
            </div>
            <doctor-info
                :doctor="doctor"
                user-type="admin"
                doctor-introduction-type="all">
            </doctor-info>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'

export default {
    data: function() {
        return {
            doctor: null,
            modalShow: false,
            isCopiedDeeplink: false,
        }
    },

    computed: {
        deeplinkUrl: function () {
            if (!this.doctor) return ''

            let url = `${location.protocol}//${location.host}/deeplink?action=reservation_doctor`
            url += `&doctor_id=${this.doctor.id}`

            return url
        },
    },

    created: function() {
        bus.$on('open-modal-admin-doctor-profile', this.open)

    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-doctor-profile')
    },

    methods: {
        /**
         * モーダル表示
         * @param {number} doctorId
         */
        open: function (doctorId) {
            this.fetchDoctor(doctorId)
            this.modalShow = true
        },

        close: function () {
            this.modalShow = false
        },

        /**
         * 医師詳細を取得
         * @param {number} doctorId
         */
        fetchDoctor: function (doctorId) {
            this.doctor = null
            const endpoint = `${constants.admin.doctors.endpoint.base}/${doctorId}`

            axios.get(endpoint).then(({data}) => {
                this.doctor = data.data
            })
        },

        /**
         * ディープリンクURLのコピー
         */
        copyDeeplink: function () {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.deeplinkUrl).then(() => {
                    this.isCopiedDeeplink = true
                    setTimeout(() => this.isCopiedDeeplink = false, 1500)
                })
            }
        },
    }
}
</script>

<style scoped lang="scss">
.modalWrapper {
    position: relative;

    .copyDeeplinkBtn {
        position: absolute;
        right: 0;
        top: 0;
        padding: 6px 12px;
        font-size: 13px;
        background: #efefef;
        border-radius: 15px;
        box-sizing: border-box;
        cursor: pointer;
        transition: background 0.2s ease-out;

        &:hover {
            background: #dcdcdc;
        }

        &.copied {
            background: #daead9;
            transition: none;

            > div {
                color: #54a450;
            }
        }
    }
}
</style>
